import { render, staticRenderFns } from "./IgnitionReport.vue?vue&type=template&id=3560bf15&scoped=true&"
import script from "./IgnitionReport.vue?vue&type=script&lang=js&"
export * from "./IgnitionReport.vue?vue&type=script&lang=js&"
import style0 from "./IgnitionReport.vue?vue&type=style&index=0&id=3560bf15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560bf15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3560bf15')) {
      api.createRecord('3560bf15', component.options)
    } else {
      api.reload('3560bf15', component.options)
    }
    module.hot.accept("./IgnitionReport.vue?vue&type=template&id=3560bf15&scoped=true&", function () {
      api.rerender('3560bf15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/IgnitionReport.vue"
export default component.exports